module.exports = __webpack_public_path__ + "img/ms.a64c57af.png";